import { useEffect, useState } from "react";

import { getTicket } from "@api/e-tickets/ticket";

export const useTicket = (ticketId: string | undefined) => {
  const [data, setData] = useState<any>({});

  const handleAddNewComment = (updatedData: any) => {
    setData((prevData: any) => ({
      ...prevData,
      ...updatedData,
    }));
  };
  // const handleAddNewComment = (commentData: any) => {
  //   setData((prevData: any) => ({
  //     ...prevData,
  //     comments: [...prevData.comments, commentData],
  //   }));
  // };

  useEffect(() => {
    getTicket(ticketId)
      .then((data) => setData(data))
      .catch((err) => console.log(err));

    return setData({});
  }, [ticketId]);

  return { data, handleAddNewComment };
};
